import { Box, Img, Stack, useColorModeValue } from "@chakra-ui/react";
import Nav from "../components/Nav";
import Signin from "../components/signin/SignIn";
import EmailScreen from "../components/signupSteps/EmailScreen";
import MoreInfoScreen from "../components/signupSteps/MoreInfoScreen";
import OTPScreen from "../components/signupSteps/OTPScreen";
import SignupSteps from "../components/signupSteps/SignupSteps";
import LandingLeftSection from "./LandingLeftSection";
import cartoon from "../assets/Character1.png";
import thelogo from "../assets/thelogo.png";
import { noMobileDisplayStyle } from "../constants";
import { UserProfileContext } from "../context/UserContext";
import UserBio from "../components/signupSteps/UserBio";
import ResetPassword from "./ResetPassword";
import ForgotPassword from "../components/signupSteps/ForgotPassword";
import { useState } from "react";
import Discover from "./dashboard/discover/Discover";
import InterestScreen from "../components/signupSteps/InterestScreen";
import LandingPage from "../components/LandingPage"

function Landing() {
  const textColor = useColorModeValue("#fff", "#fff");
  // Define the currentStep state and prevFunction within the Landing component
  const [currentStep, setCurrentStep] = useState(1);
  const [totalStep, setTotalStep] = useState(0);

  const nextFunction = () => {
    // Increment the current step when the user completes a step
    setCurrentStep(currentStep + 1);
  };

  const prevFunction = () => {
    // Increment the current step when the user completes a step
    setCurrentStep(currentStep - 1);
  };

  
  return (
    <UserProfileContext.Consumer>
      {({ state }) => {
        return (
          <>
            {state.signin && !state.forgotPassword && !state.resetPassword ? (
              // <Signin />
              <LandingPage />
            ) : state.forgotPassword ? (
              <ForgotPassword />
            ) : state.resetPassword ? (
              <ResetPassword />
            ) : (
              <SignupSteps index={state?.startFrom}>
                <EmailScreen />
                <OTPScreen />
                <UserBio />
                <MoreInfoScreen />
                <InterestScreen />
              </SignupSteps>
            )}
          </>
        );
      }}
    </UserProfileContext.Consumer>
  );
}

export default Landing;
